import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface DealerPhoneValidationAlertProps {
  canProceed: boolean;
  campaignApproved: boolean;
  isPhoneNumberReady: boolean;
}

export function DealerPhoneValidationAlert({
  canProceed,
  campaignApproved,
  isPhoneNumberReady
}: DealerPhoneValidationAlertProps) {
  if (canProceed) return null;

  let title: string;
  let message: string;
  const alertType =
    campaignApproved && isPhoneNumberReady ? "error" : "caution";

  if (!campaignApproved) {
    title = ErrorMessages.DEALER_PHONE_CAMPAIGN_NOT_APPROVED_TITLE;
    message = ErrorMessages.DEALER_PHONE_CAMPAIGN_NOT_APPROVED_MESSAGE;
  } else if (!isPhoneNumberReady) {
    title = ErrorMessages.DEALER_PHONE_NUMBER_NOT_READY_TITLE;
    message = ErrorMessages.DEALER_PHONE_NUMBER_NOT_READY_MESSAGE;
  } else {
    title = ErrorMessages.DEALER_PHONE_TEXTING_UNAVAILABLE_TITLE;
    message = ErrorMessages.DEALER_PHONE_TEXTING_UNAVAILABLE_MESSAGE;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="dealer-phone-validation-alert"
        id="DealerPhoneValidationAlert"
        role="status"
        title={title}
        type={alertType}
      >
        {message}
      </Alert>
    </StyledContainerAlert>
  );
}

export default DealerPhoneValidationAlert;
